// extracted by mini-css-extract-plugin
module.exports = {"body":"DeviceDetails_body__31p7O","cardBody":"DeviceDetails_cardBody__gCS-s","tabsContainer":"DeviceDetails_tabsContainer__3Cr-R"};